import { useAuth } from "@vellum/micro-app-auth";
import { Link } from "react-router-dom";

const SECTIONS = [
  {
    title: "Coverage",
    href: "/coverage",
    description:
      "Facilities and nurses on a map: where to hire, where to grow.",
  },
  {
    title: "Facilities",
    href: "/facilities",
    description: "Sites where jobs are scheduled, grouped by company.",
  },
  {
    title: "Companies",
    href: "/companies",
    description: "Customer organizations that own facilities.",
  },
  {
    title: "Users",
    href: "/users",
    description: "Everyone with a Luna login, and the role they hold.",
  },
  {
    title: "AnswerFirst Recipients",
    href: "/answer-first-recipients",
    description:
      "Who gets emailed when an AnswerFirst call can't become a job.",
  },
];

export function HomePage() {
  const { user } = useAuth();

  return (
    <div>
      <h1 className="mb-2 text-3xl font-bold tracking-tight text-amber-600">
        Vellum Admin
      </h1>
      <p className="mb-7 max-w-xl text-sm leading-relaxed text-gray-600">
        Administration for facilities, companies, and users. Browsing is
        available today; creating and editing records is being moved here from
        Peak Mobile.
      </p>
      <div className="mb-6 rounded-lg border border-gray-200 bg-white p-4 text-sm text-gray-700">
        Signed in as <span className="font-medium">{user?.email}</span>
      </div>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {SECTIONS.map((section) => (
          <Link
            key={section.href}
            to={section.href}
            className="rounded-lg border border-gray-200 bg-white p-4 no-underline transition-colors hover:border-amber-600"
          >
            <h2 className="mb-1 text-base font-semibold text-gray-900">
              {section.title}
            </h2>
            <p className="m-0 text-sm text-gray-600">{section.description}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
